import { CurrenciesResponse } from "@cede/types";

export * from "./app-source";
export * from "./base";
export { onIdentitySessionExpired } from "./identity-token-refresher";
export * from "./metrics-events-queue";
export * from "./metrics-flush";
export * from "./metrics-unload-batch";
export * from "./sentry-api-request-error";
export * from "./mocks";
export * from "./readAssetFromExtension";
export * from "./types";

export const fetchAvailableCurrencies = async (): Promise<CurrenciesResponse> => {
  // Mocked response
  return {
    data: {
      updatedAt: new Date().toISOString(),
      currencies: {
        fiat: ["usd"],
        crypto: [], // Return empty crypto array as per mock requirement
      },
    },
  };
};
